<div class="dialog-container" style="padding: 16px; min-width: 320px;">
    <h2 mat-dialog-title style="margin-top: 0; font-size: 18px; font-weight: 500;">Export Data For</h2>
    <div mat-dialog-content style="padding: 8px 0 16px 0;">
        <mat-radio-group [(ngModel)]="selectedExportType" [disabled]="update_schedule_at !== ''"
            style="display: flex; flex-direction: column; gap: 12px; margin: 8px 0 16px 0;">
            <mat-radio-button [value]="1" color="primary">Item Name change</mat-radio-button>
            <mat-radio-button [value]="2" color="primary">Item Price Change</mat-radio-button>
        </mat-radio-group>
        <div *ngIf="update_schedule_at"
            style="color: #e53935; font-size: 12px; margin-top: 8px; border-left: 2px solid #e53935; padding-left: 6px;">
            Note: Staged revisions of type {{ update_type === 1 ? 'Item Name change' : 'Item Price Change' }}
            are already active. Export is locked to this format. Discard drafts to change.
        </div>
    </div>
    <div mat-dialog-actions
        style="display: flex; justify-content: flex-end; gap: 8px; padding-top: 8px; border-top: 1px solid #eee;">
        <button mat-button (click)="closeDialog()">Close</button>
        <button mat-raised-button color="primary" (click)="confirmExport()">Export</button>
    </div>
</div>
